import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { DialogTitle, DialogContent, Box, Typography } from '@mui/material'

import { TextInput, ThemeButton } from '../../../../ui'

const TEXT_AREA_LENGTH = 250

export const ResolveIssueDialog = ({ close, ipId, resolveIssue }) => {
  const { formatMessage } = useIntl()

  const [loading, setLoading] = useState(false)
  const [formState, setFormState] = useState({ observaciones: '' })

  const handleChangeForm = (e) => setFormState({ ...formState, [e.target.name]: e.target.value })

  const handleSubmit = () => {
    setLoading(true)
    resolveIssue(ipId, formState)
      .then((callback) => {
        setLoading(false)
        close()
        callback.redirectToTable()
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <Box p={2}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography variant="h4" color="primary">
            {formatMessage({ id: 'pages.ip.detail.resolveIssueDialog.title' })}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" paragraph>
          {formatMessage({ id: 'pages.ip.detail.resolveIssueDialog.description.1' })}
        </Typography>
        <Typography variant="body1" paragraph>
          {formatMessage({ id: 'pages.ip.detail.resolveIssueDialog.description.2' })}
        </Typography>
        <Box pt={2}>
          <TextInput
            required={true}
            name="observaciones"
            value={formState.observaciones}
            placeholder={`Máx. ${TEXT_AREA_LENGTH} caracteres`}
            multiline={true}
            onChange={handleChangeForm}
            rows={4}
            rowsMax={4}
            // inputProps={{ maxLength: TEXT_AREA_LENGTH }} //En BE no tienen límite de caracteres
          />
        </Box>
        <Box display="flex" justifyContent="space-around" pt={3} flexWrap="wrap">
          <Box width={150} mb={[3, 0]}>
            <ThemeButton onClick={close} color="inherit" disabled={loading} fullWidth>
              {formatMessage({ id: 'global.cancel' })}
            </ThemeButton>
          </Box>
          <Box width={150}>
            <ThemeButton
              onClick={handleSubmit}
              color="primary"
              fullWidth
              loading={loading}
              disabled={loading}
            >
              {formatMessage({ id: 'global.accept' })}
            </ThemeButton>
          </Box>
        </Box>
      </DialogContent>
    </Box>
  )
}
